import { Spinner } from '@app/components/icons/spinner';
import { Dialog } from '@headlessui/react';
import cx from 'classnames';
import React, { ReactNode } from 'react';

type DialogPromptProps = {
  isShown: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: ReactNode;
  confirmText: string;
  cancelText: string;
  isLoading?: boolean;
  isDarkTheme?: boolean;
};

export const DialogPrompt = ({
  isShown,
  onClose,
  onConfirm,
  title,
  description,
  confirmText,
  cancelText,
  isLoading = false,
  isDarkTheme = false,
}: DialogPromptProps) => {
  return (
    <Dialog open={isShown} onClose={onClose} className="relative z-[999]">
      <div className="fixed inset-0 overflow-y-auto bg-gray-800/60">
        <div className="flex min-h-full items-center justify-center sm:p-4">
          <Dialog.Panel
            className={cx(
              'font-inter relative w-96 overflow-hidden rounded-lg shadow-md',
              isDarkTheme ? 'bg-gray-800 text-white' : 'bg-white text-gray-800',
            )}
          >
            <Dialog.Title className="mb-2 px-4 pt-4 text-center font-medium">
              {title}
            </Dialog.Title>

            <Dialog.Description
              className={cx(
                'mb-4 px-4 text-center text-sm',
                isDarkTheme ? 'text-gray-300' : 'text-gray-700',
              )}
            >
              {description}
            </Dialog.Description>

            <div
              className={cx(
                'mt-4 flex w-full border-t p-4 justify-between',
                isDarkTheme ? 'border-gray-600' : 'border-gray-300',
              )}
            >
              <button
                className={cx(
                  'h-10 w-40 rounded bg-transparent text-sm inline-flex items-center justify-center font-medium outline-none border',
                  isDarkTheme
                    ? 'text-gray-200 border-gray-600'
                    : 'text-gray-800 border-gray-200',
                )}
                onClick={onClose}
              >
                {cancelText}
              </button>
              <button
                className="h-10 w-40 rounded bg-primary text-sm inline-flex items-center justify-center text-white px-5 font-medium outline-none"
                onClick={onConfirm}
                disabled={isLoading}
              >
                {isLoading ? <Spinner /> : confirmText}
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
};
